/**
 * 画像情報取得要求VO
 */
export class GetImageInfoModel {
  public pcodeList: string;							        // Pコード
  public guideGoodsName: string;						    // 商品案内用商品名
  public guideStandardName: string;					    // 商品案内用規格名
  public imageName: string;							        // 画像名
  public imageFileName: string;						      // 画像ファイル名
  public imageBelongId: string;						      // 所属
  public imageKind: string;							        // 画像種類
  public imageType: string;							        // 画像種別
  public processInstruct: string;						    // 調理指示
  public remarksList: string;							      // 備考
  public cookingExPublish: string;						  // 調理例掲載区分
  public cookingDiv: string;							      // 料理分類
  public cookingNameList: string;						    // 料理名
  public materialNameList: string;						  // 材料名
  public keyWordList: string;							      // キーワード
  public eventId: string;								        // 催事・季節
  public photoContentsDiv: string;						  // 撮影内容区分
  public photoStudioId: string;						      // 撮影場所
  public imageInstructUserId: string;					  // 作成指示者
  public imageInstructDateFrom: string;				  // 作成指示日（ＦＲＯＭ）
  public imageInstructDateTo: string;					  // 作成指示日（ＴＯ）
  public fileRegistDateFrom: string;					  // 画像ファイル登録日（ＦＲＯＭ）
  public fileRegistDateTo: string;						  // 画像ファイル登録日（ＴＯ）
  public status: string;												// ステータス
  public imageInstruct: string;								  // 画像作成指示
  public enabled: string;											  // 使用停止フラグ
  public photoScheduleFrom: string;             // 撮影予定日(From)
  public photoScheduleTo: string;               // 撮影予定日(To)
  public classCode: string;                     // 部門コード
  public multipleCode: boolean;                 // 複数コード登録
  public startOrderCode: string;                // 使用開始受注コード
  public startDelivCatalogId: string;           // 使用開始配達企画回(翌週)
  public billingName: string;                   // 請求先名
  public buyerCode: string;                     // バイヤーコード
  public outputFlg: string;                     // 出力／未出力選択
  public carriedForward: boolean;               // 繰越
  public c2pfTarget: boolean;                   // C2PF対象
  public photographingChangeSchedule: boolean;  // 変更前撮影予定日
}
